import styled from 'styled-components';

export const RestAnimationStyled = styled.div`
  .animation {
    width: 100%;
  }
  text-align: center;

  .message {
    margin-top: 1rem;
    font-size: 1.2rem;
    color: #666;
  }
`;
